/*
 * @Description: 首页接口
 * @Author: Duan Yu (949267840@qq.com)
 * @Date: 2019-08-07 17:25:19
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-02-22 14:35:37
 */
import { get, post } from '@/utils/request'

// import { formatDateTime } from '@/utils/objectUtil'

// export async function getDeviceCount () {
//   const res = await get('/api/monitoring/gis/site/list/count')

//   if (res.code === 'success') {
//     const { equipCount, exceptionCount, fault: faultCount } = res.data

//     res.data = { equipCount, exceptionCount, faultCount }
//   }

//   return res
// }

// export async function getLeftList ({ type }) {
//   const res = await get(
//     `/api/monitoring/gis/${type === 'followInfo' ? 'attention' : 'alarmRecord/list'}`
//   )

//   if (res.code === 'success') {
//     res.data.list = res.data.list.map(
//       ({
//         id,
//         equipRecordName,
//         exceptionDetail,
//         describe,
//         createTime,
//         equipReccordId,
//         exceptionType,
//         thresholdsId,
//         exceptionCount,
//       }) => ({
//         id,
//         equipRecordName,
//         exceptionDetail,
//         describe,
//         formatTime: createTime ? formatDateTime(new Date(+createTime), 'MM-dd HH:mm') : createTime,
//         equipReccordId,
//         exceptionType,
//         thresholdsId,
//         exceptionCount,
//       })
//     )
//   }

//   return res
// }

// function transformItem ({ id, name, exceptionCount, faultCount, deviceCount } = {}) {
//   return {
//     id,
//     name,
//     faultCount: faultCount + exceptionCount,
//     deviceCount,
//   }
// }

// export async function getRightList () {
//   const res = await get('/api/monitoring/gis/site/node/list')

//   if (res.code === 'success') {
//     res.data.list = res.data.list.map(
//       ({ id, name, lon, lat, status, exceptionCount, faultCount, children: [up, down] }) => ({
//         id,
//         name,
//         status,
//         faultCount: exceptionCount + faultCount,
//         position: [lon, lat],
//         up: transformItem(up),
//         down: transformItem(down),
//       })
//     )
//   }

//   return res
// }

// // 进行首字母小写转换，数据裁剪
// export function transformData (data = {}) {
//   return Object.entries(data).reduce((prev, [key, val]) => {
//     const newKey = `${key[0].toLowerCase()}${key.slice(1)}`
//     let newVal = {}

//     // 处理门架开关
//     if (key === 'DoorStatus') {
//       newVal = val.value ? [val.value[2], val.value[5]] : []
//     } else if (key === 'AlermMessage') {
//       // 处理信息提示
//       newVal = val
//     } else {
//       newVal = { value: val.value, exception: val.exception }
//     }

//     return {
//       ...prev,
//       [newKey]: newVal,
//     }
//   }, {})
// }

// // 获取门架状态
// export async function getStatus (params) {
//   const res = await get('/api/monitoring/operate/get/status', params)

//   if (res.code === 'success') {
//     res.data = transformData(res.data)
//   }

//   return res
// }

// // 获取门架设备
// export async function getDevice (params) {
//   const res = await get('/api/monitoring/gis/site/road/list', params)

//   if (res.code === 'success') {
//     const {
//       computerCollect: { deviceList },
//       title,
//     } = res.data

//     res.data = { deviceList, title }
//   }

//   return res
// }

// export function operationNotify (params) {
//   return post('/api/monitoring/gis/gisOverlook', params)
// }

// export async function getDeviceDetails (params) {
//   const res = await get('/api/monitoring/gis/device/detail', params)

//   if (res.code === 'success') {
//     const {
//       problem,
//       repaireCount,
//       exceptionCount,
//       latestTimeString,
//       equip: { name },
//       location,
//       currentStatus,
//     } = res.data

//     const item = {
//       problem,
//       repaireCount,
//       exceptionCount,
//       latestTimeString,
//       title: `${name} ${location}`,
//     }

//     if (currentStatus) {
//       const { label, value, unit, exception } = currentStatus

//       Object.assign(item, { label, value, unit, exception })
//     }

//     res.data = item
//   }

//   return res
// }

// export async function getCamaraList (params) {
//   const res = await get('/api/monitoring/gis/site/camara/list', params)

//   if (res.code === 'success') {
//     res.data.list = res.data.list.map(({ name, id }) => ({ name, id }))
//   }

//   return res
// }

// 近期告警信息统计（5天告警次数、告警设备数）
export async function getStatisWarnings (data) {
  // eslint-disable-next-line no-return-await
  return await get('/api/v2/device-warning/statis-warnings', data)
}

// 告警处理统计-（type=0:本周、type=1:本月、type=2:本年：每个用户处理的告警数量）
export async function getStatisHandle (params) {
  // eslint-disable-next-line no-return-await
  return await get('/api/v2/device-warning/statis-handle', params)
}
// 实时数据
export async function getData (params) {
  // eslint-disable-next-line no-return-await
  return await get('/api/device-info/lookout/statis', params)
}
// 获取哨兵二代数据
export async function getHistoryData (params) {
  return await get('/api/device-warning-info/sentry_ii/statis', params)
}
/**
 * @description   获取用户管理列表
 * @param {*} params
 */
export async function getList () {
  const res = await get('/api/hrm/all')
  if (res.code === 'success') {
    res.data.list = res.data.list.map(
      ({ password, sex, loginTime, isValid, openid, mpopenid, ...rest }) => ({
        ...rest,
        sex,
        isValid,
        openid,
        mpopenid,
        sexName: sex === '1' ? '男' : '女',
        isValidName: isValid === '1' ? '可用' : '不可用',
        openidName: openid ? '已绑定' : '未绑定',
        mpopenName: !mpopenid ? '已注销' : '未注销',
      })
    )
  }
  return res
}

/**
 * @description   通过cameraNum(摄像机编号)拉取相应的视频流地址
 * @param {*} cameraNum cameraNum是在告警信息列表中返回的
 */
export const getVideo = (cameraNum) => {
  return get(`/api/video/${cameraNum}`)
}
/**
 * @description   告警设备 (警示灯, 情报板) 参数暂时写死
 * @param {*} groupIdList  groupIdList === '3-4'
 * @param {*} type  type === '0'
 */
export const otherDevice = (groupIdList, type) => {
  return get('/api/device-info/list-install/other', { groupIdList, type })
}
/**
 * @description   摄像机列表
 */
export const cameraList = () => {
  return post('/api/cameraInfo/queryAll')
}

// 保存设备修改信息
export const deviceInfoSave = (params) => {
  return post('/api/device-info/modify', params)
}
